import {UserRole} from '@ew/enums';

export class GlobalUserState {
  static #USER_ROLE: UserRole;

  static get userRole() {
    return this.#USER_ROLE;
  }

  static set userRole(value: UserRole) {
    this.#USER_ROLE = value;
  }
}
